<template>
  <AffiliatePage />
</template>

<script>
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'
import AffiliatePage from '@/components/Affiliate.vue'

export default {
  name: 'Affiliate',
  components: {
    // HelloWorld
    AffiliatePage
  }
}
</script>
